import { Button } from '../ui/button';

export function TBH() {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center text-center px-4">
      <div className="flex flex-col items-center gap-4">
        <span className="text-7xl font-extrabold text-primary-600 dark:text-primary-400">TBH</span>
        <h1 className="text-3xl md:text-4xl font-bold mb-2">This Page Will Be Here Soon</h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-6 max-w-md">
          We&apos;re working hard to bring this page to you. Please check back later!
        </p>
        <Button href="/">Go Home</Button>
      </div>
    </div>
  );
}
